import * as Moment from 'moment-timezone';
type Unit = Moment.unitOfTime.Diff;

export type TimerFunction = {
    stop: (unit: Unit) => number;
}

export function StartTimer(): TimerFunction {
    const startTime = Moment();

    return {
        stop: (unit: Unit) => Moment().diff(startTime, unit)
    }
}


// WEBPACK FOOTER //
// ./packages/platform-utils/services/timeMeasuring.ts